import { useNavigate } from "react-router-dom";
import { useAuth } from "../authContext.js";
import PropTypes from 'prop-types';

export default function ProtectedRoute({ children }) {
  const { user, authMethod, loginCas } = useAuth();
  const navigate = useNavigate();
  
  if (user) {
    return children;
  }

  if (authMethod.toLowerCase() === 'cas') {
    loginCas();
  } else {
    navigate('/login');
  }

  return null;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node,
};
